import { useEffect } from 'react';
import { config } from 'src/config';

declare global {
  interface Window {
    FrontChat?: any;
  }
}

export function useFrontChat() {
  useEffect(() => {
    if (!config.enableChat) return;

    const script = document.createElement('script');
    script.src = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';
    script.async = true;
    document.body.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.FrontChat && window.FrontChat('init', {
        chatId: '${config.frontChatId}',
        useDefaultLauncher: true
      });
    `;

    script.onload = () => {
      document.body.appendChild(inlineScript);
    };

    return () => {
      document.body.removeChild(script);
      if (inlineScript.parentNode) {
        document.body.removeChild(inlineScript);
      }
    };
  }, []);
} 